var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      attrs: { "escape-close": "", value: "" },
      on: {
        input: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c(
        "w-card",
        { staticClass: "epson-card", attrs: { "max-width": "1200" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$ct("epson-print-title")) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c("iframe", {
            ref: "frame",
            staticClass: "epson-frame",
            attrs: {
              src: _vm.iframeUrl,
              frameborder: "0",
              allow: "clipboard-write",
            },
          }),
          _vm.status
            ? _c(
                "div",
                {
                  staticClass: "epson-status",
                  class: { error: _vm.hasError, ok: !_vm.hasError },
                },
                [
                  _c("w-fa", {
                    attrs: {
                      icon: _vm.hasError
                        ? "exclamation-circle"
                        : "check-circle",
                    },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.status))]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }